import script from "./ShopPageMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopPageMobile.vue?vue&type=script&setup=true&lang=js"

import "./ShopPageMobile.vue?vue&type=style&index=0&id=d1a78632&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1a78632"]])

export default __exports__